import {EtsyShop} from '@coolcolduk/etsy';
import {Document, Image, Link, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import {getFirebaseFunction} from '../../../setup/firebase';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  section: {
    marginTop: '5%',
    // marginBottom: '5%',
    marginLeft: '5%',
    // marginRight: '5%',
    width: '90%',
    height: '90%',
    padding: 10,
    border: '1 solid black',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    textAlign: 'center',
    width: '200px',
    height: '200px',
  },
  break: {
    textAlign: 'center',
    height: '20px',
  },
  shopName: {
    textAlign: 'center',
    width: '100%',
    fontSize: 24,
    paddingBottom: '16px',
  },
  title: {
    textAlign: 'center',
    width: '100%',
    fontSize: 24,
    paddingBottom: '16px',
  },
  link: {
    textAlign: 'center',
    width: '100%',
    fontSize: 12,
  },
  instruction: {
    textAlign: 'center',
    width: '100%',
    fontSize: 12,
    fontWeight: 'bold',
    // marginBottom: 5,
  },
});

export interface EtsyNewSingleListingPdfProps {
  title: string;
  link: string;
  instruction: string;
  shop?: EtsyShop;
}

export default function EtsyNewSingleListingPdf({shop, link, instruction, title}: EtsyNewSingleListingPdfProps) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <>
          <View style={styles.section}>
            {shop?.icon_url_fullxfull && (
              <Image
                style={styles.image}
                src={{
                  uri: `${getFirebaseFunction('etsy')}/fetchFile?url=${shop.icon_url_fullxfull}`,
                  method: 'GET',
                  headers: {'Cache-Control': 'no-cache'},
                }}
              />
            )}

            <Text style={styles.break}> </Text>
            <Text style={styles.shopName}>{shop?.shop_name || ''}</Text>
            <Text style={styles.title}>{title}</Text>

            <Text style={styles.break}> </Text>
            <Text style={styles.link}>Download link:</Text>
            <Text style={styles.link}>
              <Link src={link}>{link}</Link>
            </Text>

            {instruction && (
              <>
                <Text style={styles.break}> </Text>
                <Text style={styles.instruction}>Instruction:</Text>
                <Text style={styles.instruction}>
                  <Link src={instruction}>{instruction}</Link>
                </Text>
              </>
            )}
          </View>
        </>
      </Page>
    </Document>
  );
}
